import React, {Dispatch, SetStateAction, useEffect, useState, useRef} from 'react';
import Divider from '../../generic/Divider';
import { localizeDate } from '../../../lib/utils/format';
import FormButton from "../../generic/buttons/main";
import './style.scss'
import Feedback from "../../common/Feedback";
import {BASE_SILAVETRA_URL} from "../../../lib/api/globalState";
import i18next from "i18next";
import { Trans } from 'react-i18next';
import useFinal from "./useFinal";
import {TOrder} from "../../../lib/utils/types";
import {useInjection} from "brandi-react";
import {GlobalSettingsModelStoreToken} from "../../../entities/globalConfig/model";
import ElementWithAccessInCountries from 'lib/utils/hocs/ElementWithAccessInCountries';
import useSendPurchaseAnalytics from "../../../lib/utils/hooks/useSendPurchaseAnalytics";
import {sendYandexMetrikaRgsEvent} from '../../../lib/utils/analytics';
// @ts-ignore
import { PRODUCT_TYPES } from "sv-common/constants/certificates";
import PreparationSteps from "../../generic/PreparationSteps";
import {Button} from "reactstrap";
import SuccessMessage from "../../common/finalSuccessMessage";

type TProps = {
    payingUser: any
    setOrder: Dispatch<SetStateAction<TOrder | undefined>>
    orderId: string | number
    onNewBookingClick: () => void
    order?: TOrder
}

const Final = ({ payingUser, setOrder, order, orderId, onNewBookingClick }: TProps) => {
    useFinal(orderId, setOrder)
    const {t, language} = i18next;
    const hasSentViewEvent = useRef(false);

    const globalSettings = useInjection(GlobalSettingsModelStoreToken);

    const phoneText = t('final.contactPhone');
    const emailText = t('final.contactEmail');
    const telegramText = t('final.contactTelegramShort');

    // @ts-ignore
    useSendPurchaseAnalytics(order, PRODUCT_TYPES.SLOTS);

    useEffect(() => {
        if(!hasSentViewEvent.current && order?.hasPaid) {
            sendYandexMetrikaRgsEvent('rgs-view_page-form_view');
            hasSentViewEvent.current = true;
        }
    }, [order?.hasPaid]);

  return (

    <div className="final">
        {!order?.hasPaid
            ? <div className="final__title">{t('final.processing')}</div>
            : <div className="final__title">
                {t('final.eventSuccess', {date: localizeDate(order?.slot?.start_date, language)})}
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                  <>
                    <p className="pt-3 pt-md-4">
                      {t('final.confirmationEmail')}
                      <SuccessMessage text={"eventSuccessEmail"}/>
                    </p>
                  </>
                </ElementWithAccessInCountries>
              </div>
        }
        <PreparationSteps
                order={order}
                productType={PRODUCT_TYPES.SLOTS}
                globalInsuranceEnabled={globalSettings.config['insurance_available']}
                globalInsuranceSport={globalSettings.config['insurance_available_sport']}
                globalInsuranceAdventure={globalSettings.config['insurance_available_adventure']}
                userData={payingUser}
                setOrder={setOrder}
        />
        <div className="final_buttons">
            <Button type={'button'} onClick={() => onNewBookingClick()} className={'btn-case-lower'}>
              {t('final.bookMore')}
            </Button>
            <a href={BASE_SILAVETRA_URL} className="button_links">
                <FormButton value={t('final.onTheMain')} type={'button'} disabled={false} className={'btn-muted'}
                            onClick={undefined}/>
            </a>
        </div>
    <Divider />
    <Feedback/>
    <br/>
    </div>
  )
}

export default Final;
